import styled from "styled-components";

const parsedHtml = styled.div`
  > h1{
    font-size: 5.6rem;
    letter-spacing: -1.8px;
    font-weight: 900;
    line-height: 1;
  }
  > h2{
    font-size: 3.75rem;
    letter-spacing: -1.2px;
    font-weight: 300;
    line-height: 1;
  }
  > h3{
    font-size: 2.5rem;
    letter-spacing: 0px;
    line-height: 1;
  }
  > p{
    font-size: 1.875rem;
    letter-spacing: 0px;
    line-height: 1.5;
    font-weight: 300;
  }
`

export default parsedHtml